<div class="app-strategy" [ngClass]="{ 'increase-margin': stepStatus === 5 }">
  <ng-container *ngIf="isInitialised">
    @if (isEve2) {
      @if (qlOnboardingStep === 1) {
        <app-strategy-intro></app-strategy-intro>
      } @else {
        <app-setup-strategy-tabs
          *ngIf="isEditModeEve2$ | async"
          [highestTabIndex]="highestTabIndex"
          [is3aPillar]="productType === '3a'"
          [step]="stepStatus"
          [tabSelected]="tabSelected"
        ></app-setup-strategy-tabs>
        <app-setup-strategy [step]="stepStatus" [is3aPillar]="productType === '3a'" [tabSelected]="tabSelected"></app-setup-strategy>
      }
    } @else {
      <app-strategy-tabs
        *ngIf="editMode"
        [highestTabIndex]="highestTabIndex"
        [is3aPillar]="productType === '3a'"
        [step]="stepStatus"
        [strategyWasChanged]="strategyWasChanged"
        [tabSelected]="tabSelected"
      ></app-strategy-tabs>
      @if (productType === '3a') {
        <app-strategy-3a [step]="stepStatus" [tabSelected]="tabSelected" [qlOnboardingStep]="qlOnboardingStep"></app-strategy-3a>
      } @else {
        <app-strategy-ch [step]="stepStatus" [tabSelected]="tabSelected" [qlOnboardingStep]="qlOnboardingStep"></app-strategy-ch>
      }
    }
  </ng-container>
</div>

<app-dialog-tree-planted *ngIf="treesModalOpened"></app-dialog-tree-planted>
<app-strategy-notification></app-strategy-notification>

<ng-container *ngIf="canShowInterviewWidget">
  <app-strategy-interview-notification
    *ngIf="showInterviewNotification"
    [showNotification]="showInterviewNotification"
    (showWidget)="showInterviewModal($event)"
  ></app-strategy-interview-notification>
  <app-strategy-interview-widget
    *ngIf="showInterviewWidget"
    [showWidget]="showInterviewWidget"
    (closeWidget)="hideInterviewModal()"
  ></app-strategy-interview-widget>
</ng-container>

<ng-container *ngIf="!(flipperBrokenPf$ | async)?.attributes.value">
  <app-dialog-portfolio-warning
    *ngIf="showPortfolioWarningModal$ | async"
    [undoLoading]="portfolioUndoLoading$ | async"
    (closeWarning)="onCloseWarning()"
    (undoChange)="onUndoChange()"
  >
  </app-dialog-portfolio-warning>
</ng-container>

<app-dialog-portfolio-spinner
  @ngIfAnimation
  *ngIf="generateProfileLoader$ | async"
  [showSpinner]="generateProfileLoader$ | async"
  [dataLoading]="showGeneratingSpinner"
  [numberOfCompanies]="numberOfCompanies$ | async"
  [isEve2]="isEve2"
  (closeLoader)="onCloseLoader($event)"
></app-dialog-portfolio-spinner>

<ng-container *ngIf="showEve2Modal">
  <app-dialog-eve2-explanation (dialogClose)="onDismissEve2Modal($event)"></app-dialog-eve2-explanation>
</ng-container>
